import microsoftSrc from '@corbado/shared-ui/assets/microsoft.svg';
import React from 'react';
import { Icon } from './Icon';
export const MicrosoftIcon = props => {
    return (React.createElement(Icon, { src: microsoftSrc, ...props }));
};
export default MicrosoftIcon;
